import DOMPurify from "isomorphic-dompurify"
import { Marked } from "marked";

const marked = new Marked();

(async () => {
    const markedHighlight = await import("marked-highlight");
    const hljs = await import('highlight.js');

    marked.use(markedHighlight.markedHighlight({
        emptyLangClass: 'hljs',
        langPrefix: 'hljs language-',
        highlight(code, lang) {
            const language = hljs.default.getLanguage(lang) ? lang : 'plaintext';
            return hljs.default.highlight(code, { language }).value;
        }
    })

    )
})()

import("marked-katex-extension").then(x => 
    marked.use(x.default({
        throwOnError: false,
        nonStandard: true
    }))
)

export function processMarkdown(content: string, allowHTML: boolean = false): string {
    content = content.replaceAll(/[^\\]\$(\d+\.?,?)+(?! [\\+\-\*\/])\s/g, "\\$&");
    content = content.replaceAll(/<think>[^]*?<\/think>/g, "");
    content = content.replaceAll("\\(", "$").replaceAll("\\)", "$")
    content = content.replaceAll("$$", "\n\n$$\n\n")
    // HACK: 1. doesn't turn into a list!
    if (content.endsWith("."))
        content = content.slice(0, content.length-1) + "\\."

    let html = marked.parse(content, {async: false});
    if (!allowHTML)
        html = DOMPurify.sanitize(html);

    // make images use absolute paths
    if (typeof window !== "undefined") {
        const baseUrl = window.location.origin + window.location.pathname.replace(/\/$/, "");
        const div = document.createElement("div");
        div.innerHTML = html;
        div.querySelectorAll("img").forEach(img => {
            const src = img.getAttribute("src");
            if (src && !/^https?:\/\//i.test(src) && !src.startsWith("/")) {
                img.setAttribute("src", `${baseUrl}/${src}`);
            }
        });
        html = div.innerHTML;
    }

    // make anchors open in new tab
    {
        const div = document.createElement("div");
        div.innerHTML = html;
        div.querySelectorAll("a").forEach(a => {
            a.target="_blank";
        });
        html = div.innerHTML;
    }

    return html;
}

// for tts
export function toSpeechText(content: string) {
    content = content.replaceAll("\\sqrt", " square root of ")
    // remove all emoji
    content = content.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');

    console.log('input', content)
    const html = processMarkdown(content);
    const div = document.createElement("div")
    div.innerHTML = html;

    // remove unreadable stuff
    const paras = div.getElementsByClassName('katex-mathml');
    while(paras[0]) {
        paras[0].parentNode!.removeChild(paras[0]);
    }

    // remove large code tags
    const codeTags = div.querySelectorAll('code');

    codeTags.forEach(tag => {
        if (tag.innerText.length > 2*80) tag.remove()
        //console.log(tag.innerText, tag.innerText.length)
        //const textContent = codeTag.innerText;
        //const numericValue = Number(textContent);
        //console.log(textContent)

        // // Check if the inner text is a number and greater than the threshold
        // if (!isNaN(numericValue) && numericValue > threshold) {
        //     codeTag.remove(); // Remove the <code> tag from the DOM
        // }
    });

    // console.log('html', div.innerHTML)
    // console.log('innerText', div.innerText)
    return div.innerText
}